// ##### 25-02-05 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-21
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
// ##### 25-05-21 Komarov
import CartGalleryShortVersion from '../../Library/PageDevices/CartGallery/CartGalleryShortVersion';
import LoadingMessage from '../../Library/PageDevices/LoadingMessage';

// ##### Komarov 2025-07-21
const CartDetailsDiv = ({ cart, className, cartClass }) => {
  // ##### Komarov 2025-08-05
  const CartDetailsHeader = useLocalizedText('CartDetailsHeader');
  const CartDetails_1 = useLocalizedText('CartDetails_1');
  const CartDetails_2 = useLocalizedText('CartDetails_2');
  const BookingAddDetails = useLocalizedText('BookingAddDetails');
  const TaxDetails = useLocalizedText('TaxDetails');

  const tourcontents = useSelector(state => state.content.content);

  // ##### 2025-09-11 Komarov
  const hotelcontent_loaded = useSelector(
    state => state.hotelcontent.hotelcontent_loaded
  );
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);

  // ##### 25-02-19 Komarov
  const content =
    parseInt(cart.service_type_id) === parseInt('11')
      ? tourcontents
      : // : hotelcontents;
      [];

  return (
    <div
      className={`${cartClass ? cartClass : className}`}
      data-component="CartDetailsDiv"
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h2
          style={{
            color: '#003057',
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'center',
            order: '-2',
          }}
        >
          {
            // ##### 23-10-04 Komarov
            CartDetailsHeader
          }
        </h2>
        {
          // ##### Komarov 2025-05-26
          ((!hotelcontent_loaded || !hotelcontent.data?.hotels[cart.id]) && (
            <LoadingMessage loadingMessageClass="RateLoading" />
          )) || (
            <>
              <h3
                style={{
                  color: '#003057',
                  fontSize: '22px',
                  textAlign: 'center',
                  order: '-1',
                }}
              >
                {hotelcontent.data.hotels[cart.id].ho_title}
              </h3>
              <div style={{ order: '0' }}>
                <CartGalleryShortVersion
                  // ##### 25-04-21 Komarov
                  photos={hotelcontent.data.hotels[cart.id].image}
                />
              </div>
              <div
                style={{
                  order: '1',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <h4>
                  {
                    // ##### 23-10-04 Komarov
                    CartDetails_1
                  }
                </h4>
                <div
                  style={{
                    textAlign: 'justify',
                    padding: '0.5vh',
                  }}
                >
                  {/*##### 25-05-10 Komarov*/}
                  {hotelcontent.data.hotels[cart.id].summary &&
                    parse(hotelcontent.data.hotels[cart.id].summary)}
                </div>
              </div>
            </>
          )
        }
        {/* ##### 25-02-19 Komarov: TODO: Нужно будет как-то переделать код, связанный с турами: показываю этот фрагмент только в случае, если производится заказ тура */}
        {parseInt(cart.service_type_id) === parseInt('11') &&
          (content.length > 0 ? (
            content.map(item => {
              return (
                // ##### 24-04-17 Komarov
                <React.Fragment key={uniqueId()}>
                  <div
                    style={{
                      order: '2',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {item.content_name === 'Inclusion' ? (
                      <>
                        <h4>Tour Inclusions</h4>
                        <div
                          style={{
                            textAlign: 'justify',
                            padding: '0.5vh',
                          }}
                        >
                          {parse(item.text)}
                        </div>
                      </>
                    ) : null}
                  </div>
                </React.Fragment>
              );
            })
          ) : (
            <div>
              <LoadingMessage loadingMessageClass="RateLoading" />
            </div>
          ))}
      </div>
      <h4>
        {
          // ##### 23-10-04 Komarov
          CartDetails_2
        }
      </h4>
      <div className="MainRateDetails">
        <h5>
          {
            // ##### 23-10-04 Komarov
            BookingAddDetails
          }
        </h5>
        <div className="TaxDetails">
          {
            // ##### 23-10-04 Komarov
            TaxDetails
          }
        </div>
      </div>
    </div>
  );
};

export default CartDetailsDiv;
